
import React, { useContext, useEffect, useState } from 'react'
import Application from '../../StateContext/Application';

const ClosedTickets = () => {

    const statecalls = useContext(Application);
    const { CloseTicket,ReopentheTicket } = statecalls;
    const [closetickets, setCloseTickets] = useState([])
    const [status, setStatus] = useState('Close');

    useEffect(() => {
        GetClose()
    }, [])

    async function GetClose() {
        let data = await CloseTicket()
        console.log(data);

        setCloseTickets(data)
    }

    const handleButtonClick = async (id) => {
        if (status === 'Close') {
            setStatus('Open');
            let data = await ReopentheTicket(id, 'Reopen By User');
            console.log(data);
            alert(data.message);
            window.location.href = '/AdminDashboard/ViewTicket'
        }
    };

    return (
        <>
            <div className='grid justify-center'>
                <div>
                    <h1>Closed Tickets</h1>
                </div>
                <table className="border-collapse border border-slate-400 mt-2 text-center">
                    <thead>
                        <tr>
                            <th className="border bg-slate-300">Complaint ID</th>
                            <th className="border bg-slate-300">Department ID</th>
                            <th className="border bg-slate-300">Ticket Status</th>
                            <th className="border bg-slate-300">Ticket ID</th>
                            <th className="border bg-slate-300">User ID</th>
                            <th className="border bg-slate-300">Action</th>

                        </tr>
                    </thead>
                    <tbody>
                        {
                            Array.isArray(closetickets) && closetickets.map((e) => {
                                return (
                                    <tr>

                                        <td className="border border-slate-300">{e.ComplaintID}</td>
                                        <td className="border border-slate-300">{e.Department_ID}</td>

                                        <td className="border border-slate-300">{e.TicketStatus}</td>
                                        <td className="border border-slate-300">{e.Ticketid}</td>
                                        <td className="border border-slate-300">{e.Userid}</td>
                                        <td className="btn btn-primary"><button type="button" onClick={() => handleButtonClick(e.Ticketid)}>Reopen Ticket</button></td>
                                    </tr>
                                )
                            })
                        }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default ClosedTickets
